module.exports = __webpack_public_path__ + "img/cards-open.db019c41.svg";